"use strict";
/// <reference types="node" />
Object.defineProperty(exports, "__esModule", { value: true });
var BitReader = /** @class */ (function () {
    function BitReader(buffer, bufferBits) {
        if (bufferBits === void 0) { bufferBits = 8; }
        this.buffer = buffer;
        this.bufferBits = bufferBits;
        this.offset = 0;
        this.currentBit = 0;
        this.currentBuffer = 0;
        if (bufferBits !== 8 && bufferBits !== 16 && bufferBits !== 32) {
            throw new Error('bufferBits should be 8, 16 or 32');
        }
    }
    Object.defineProperty(BitReader.prototype, "ended", {
        get: function () {
            return this.offset >= this.buffer.length && this.currentBit === 0;
        },
        enumerable: true,
        configurable: true
    });
    BitReader.prototype.readBit = function () {
        if (this.currentBit === 0) {
            this.currentBuffer = 0;
            for (var bufferByte = this.bufferBits / 8 - 1; bufferByte >= 0; bufferByte--) {
                this.currentBuffer += this.readByte() << (8 * bufferByte);
            }
            this.currentBit = this.bufferBits;
        }
        return (this.currentBuffer >> --this.currentBit) & 1;
    };
    BitReader.prototype.readByte = function () {
        return this.buffer.readUInt8(this.offset++);
    };
    return BitReader;
}());
exports.BitReader = BitReader;
exports.default = BitReader;
